/* 布局 */
//前台
import Layout from "@views/layout";

const gravelatticeburialRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "gravelatticeburial/list",
        name: "GRAVELATTICEBURIAL",
        meta: {
            title: "墓区格位存放管理",
            keepAlive:true
        },
        component: () => import("@views/business/gravelatticeburial/index.vue"),
    },
        ],
};

export default gravelatticeburialRouter;
